import React, { useEffect, useMemo, useRef, useState } from 'react';
import { LAT_LNG_DECIMAL_PLACES } from './RulerLegOverlayComponent';
import { isNil } from 'lodash';
import appTheme from '../theme/appTheme.json';

interface LatLngMapDisplayProps {
  map: google.maps.Map;
}

const LatLngMapDisplay: React.FC<LatLngMapDisplayProps> = ({ map }) => {
  const [cursorLatLng, setCursorLatLng] = useState<google.maps.LatLng>();
  const mouseMoveEventListener = useRef<google.maps.MapsEventListener | null>(null);
  const mouseOutEventListener = useRef<google.maps.MapsEventListener | null>(null);

  // Create a div to display the lat long
  const latLongControl = useMemo(() => {
    const latLongDisplay = document.createElement('div');

    // Style the lat long display
    latLongDisplay.title = 'Cursor Lat/Long Display';
    latLongDisplay.style.backgroundColor = 'transparent';
    latLongDisplay.style.color = appTheme.primaryTextColor;
    latLongDisplay.style.fontSize = '12px';
    latLongDisplay.style.fontWeight = 'bold';
    latLongDisplay.style.fontFamily = appTheme.appFontFamily;
    latLongDisplay.style.lineHeight = '20px';
    latLongDisplay.style.marginRight = '12px';
    latLongDisplay.style.marginTop = '3px';
    latLongDisplay.style.pointerEvents = 'none';

    return latLongDisplay;
  }, []);

  // Update the lat long display with user's cursor position (lat / long)
  useEffect(() => {
    latLongControl.textContent = `Lat: ${
      !isNil(cursorLatLng?.lat()) ? (cursorLatLng as google.maps.LatLng).lat().toFixed(LAT_LNG_DECIMAL_PLACES) : '-'
    } / Long: ${
      !isNil(cursorLatLng?.lng()) ? (cursorLatLng as google.maps.LatLng).lng().toFixed(LAT_LNG_DECIMAL_PLACES) : '-'
    }`;
  }, [cursorLatLng, latLongControl]);

  // Handle map listeners
  useEffect(() => {
    mouseMoveEventListener.current = map.addListener('mousemove', (event: google.maps.MapMouseEvent) => {
      if (event.latLng) {
        setCursorLatLng(event.latLng);
      }
    });

    mouseOutEventListener.current = map.addListener('mouseout', () => {
      setCursorLatLng(undefined);
    });

    // Add the lat long display to the map above the other controls (which have position RIGHT_TOP)
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(latLongControl);

    return () => {
      // Remove the event listener from the map
      if (mouseMoveEventListener.current) {
        mouseMoveEventListener.current.remove();
        mouseMoveEventListener.current = null;
      }

      if (mouseOutEventListener.current) {
        mouseOutEventListener.current.remove();
        mouseOutEventListener.current = null;
      }
    };
  }, [map, latLongControl]);

  return null;
};

export default LatLngMapDisplay;
